<!-- Body Content-->
<div class="md:pt-3 pt-2 md:px-4 px-3 pb-8 mb-4">
  <div class="flex align-items-center justify-content-between">
      <h1 class="text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1">
        {{'CAMPAIGN.CAMPAIGN_DETAILS' | translate}} <i class="fa fa-circle-question text-xl text-600 cursor-pointer ml-2" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i>
      </h1>
  </div>
  <div class="mt-1 mb-3">
    <app-breadcrumb></app-breadcrumb>
  </div> 

  <!-- Card -->
  <div class="surface-0 shadow-2 border-round px-3 md:px-4 pt-3 pb-2 text-sm mt-3 relative">
      <!-- Grid -->
      <div class="grid align-items-center">
          <!-- Column -->
          <div class="col-12 xl:col-5">
              <div *ngIf="!showSkeleton">
                  <strong class="block text-lg">{{ campaign.campaign_name }}</strong>
                  <div class="text-600 mt-1 line-height-3">{{ campaign.campaign_description }}</div>
              </div>

              <div *ngIf="showSkeleton">
                  <p-skeleton height="1.35rem" width="10rem"></p-skeleton>
                  <p-skeleton height="1.35rem" styleClass="mt-1"></p-skeleton>
                  <p-skeleton height="1.35rem" styleClass="mt-1"></p-skeleton>
              </div>
          </div>

          <!-- Column -->

          <!-- Column -->
          <div class="col-6 md:col-4 xl:col-2">
              <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.CREATED_BY' | translate}}</label>
              <div *ngIf="!showSkeleton && (staffInfo | async ) as staff" class="relative">
                  <div class="flex align-items-center cursor-pointer" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                      <ng-container *ngIf="staff.ff_picture;else noImage">
                          <p-avatar [image]="staff.ff_picture" shape="" styleClass="mr-2 overflow-hidden border-round"></p-avatar>
                      </ng-container>
                      <ng-template #noImage>
                          <p-avatar [label]="client2LetterName(staff.name) | titlecase | shortName" shape="" styleClass="mr-2 overflow-hidden border-round"></p-avatar>
                      </ng-template>
                      <span class="text-primary text-sm">{{staff.name}}</span>
                  </div>

                  <!-- Dropdown -->
                  <div class="border-round shadow-2 absolute text-600 hidden origin-top w-22rem left-0 top-0 mt-6 z-2">
                      <!-- Dropdown Content -->
                      <div class="surface-0 flex align-items-center justify-content-between p-3">
                          <div class="flex align-items-center">
                              <span class="text-base font-medium text-800">{{ staff.department }}</span>
                          </div>
                          <span class="text-xxs border-1 border-primary border-round text-primary bg-blue-50 p-1 uppercase font-bold">{{ staff.designation }}</span>
                      </div>
                      <!-- Dropdown Content -->

                      <!-- Dropdown Footer -->
                      <div class="p-3 flex align-items-center justify-content-between surface-200 text-900">
                          <div class="flex align-items-center">
                              <i class="fa fa-phone mr-2 text-500"></i>
                              {{ staff.mobile_country_code }} {{ staff.mobile_number }}
                          </div>
                          <div class="flex align-items-center">
                              <i class="fa fa-envelope mr-2 text-500"></i>
                              {{ staff.email_id }}
                          </div>
                      </div>
                      <!-- Dropdown Footer -->
                  </div>
                  <!-- Dropdown -->
              </div>
              <div *ngIf="showSkeleton" class="flex align-items-center">
                  <p-skeleton height="2rem" width="2rem" styleClass="border-round mr-2"></p-skeleton>
                  <p-skeleton height="1.35rem" width="5rem"></p-skeleton>
              </div>
          </div>
          <!-- Column -->

          <!-- Column -->
          <div class="col-6 md:col-4 xl:col-3">
              <div class="flex">
                  <div class="w-6">
                      <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.CREATED_ON' | translate}}</label>
                      <strong *ngIf="!showSkeleton">{{campaign.created_date | DayAgo}}</strong>
                      <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="8rem"></p-skeleton>
                  </div>
                  <div class="w-6">
                      <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.SCHEDULE_DATE' | translate}}</label>
                      <strong *ngIf="!showSkeleton && campaign.campaign_date">{{ campaign.campaign_date | datetimeformat : 'defaultformat' }}</strong>
                      <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="8rem"></p-skeleton>
                  </div>
              </div>
          </div>
          <!-- Column -->

          <!-- Column -->
          <!-- <div class="col-12 md:col-4 xl:col-2 absolute right-0 top-0 px-3 mt-1 md:static md:mt-0">
        <div *ngIf="!showSkeleton" class="flex align-items-center justify-content-between md:justify-content-end">
        <p-tag styleClass="md:mr-4 text-xs font-normal uppercase white-space-nowrap"
        severity="success">Active</p-tag>
        <div class="">
          <p-button icon="fa fa-angle-down" [label]="'common.BUTTONS.BTN_ACTIONS' | translate" iconPos="right" styleClass="surface-0 p-button-outlined border-300 text-600 text-sm" (click)="member1.toggle($event)"></p-button>
          <p-popover #member1 styleClass="overflow-hidden right-0 text-sm w-8rem">
            <ng-template pTemplate>
              <ul class="list-none -m-4 px-0 py-2 text-xs text-600">
                <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"><i
                    class="fa fa-pencil text-500 mr-2"></i>Edit</li>
                <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"><i
                    class="fa fa-eye text-500 mr-2"></i>Mark Active</li>
                <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"><i
                    class="fa fa-eye-slash text-xl-circle text-500 mr-2"></i>Mark In-active</li>
                <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"><i
                    class="fa fa-trash-alt text-500 mr-2"></i>Delete</li>
              </ul>
            </ng-template>
          </p-popover>
        </div>
      </div>
      <div *ngIf="showSkeleton" class="flex align-items-center justify-content-between md:justify-content-end">
        <p-skeleton height="1.8rem" width="4rem" styleClass="mr-2"></p-skeleton>
        <p-skeleton height="2rem" width="6rem"></p-skeleton>
      </div>

      </div> -->
          <!-- Column -->
      </div>
      <!-- Grid -->
  </div>
  <!-- Card -->

  <!-- Card -->
  <div class="surface-0 shadow-2 border-round text-sm mt-3">
      <!-- Card Header -->
      <div class="flex align-items-center justify-content-between py-2 px-3 cursor-pointer border-bottom-1 border-300" (click)="showActionGroup1=!showActionGroup1">
          <div class="bg-primary border-round-3xl font-bold text-center text-xs py-2 px-4">{{'CAMPAIGN.ADD_GROUP' | translate}}</div>
          <i class="fa text-primary" [ngClass]="showActionGroup1 ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down' "></i>
      </div>
      <!-- Card Header -->

      <!-- Card Body -->
      <div *ngIf="showActionGroup1" class="p-3">
          <div class="mb-3">
              <!-- <img src="/assets/img/campaign-details-img.png" alt="Image" /> -->
              <query-builder *ngIf="sqlRule"
                [tenantId]="tenantId"
                [eventType]="'Campaign'"
                [query]="sqlRule"
                [isDisabled]="true">
              </query-builder>
          </div>

          <!-- Email Block -->
          <div class="bg-cyan-50 border-1 border-cyan-500 border-round mt-3" *ngIf="showEmailData.value">
              <!-- Block Header -->
              <div class="border-round-top flex align-items-center bg-cyan-500 text-white p-3">
                  <i class="fa fa-envelope mr-2"></i>
                  <strong>{{'CAMPAIGN.TABLE.SEND_EMAIL' | translate}}</strong>
              </div>
              <!-- Block Header -->

              <!-- Block Body -->
              <div class="px-3 pt-3 pb-1">
                  <strong *ngIf="!showSkeleton" class="block text-base text-cyan-500" [innerHTML]="'CAMPAIGN.RECEPIENTS' | translate : {count:campaAction.email_total_count}"></strong>
                  <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="14rem"></p-skeleton>

                  <!-- Grid -->
                  <div class="grid align-items-center mt-3">
                      <!-- Column -->
                      <!-- <div class="col-6 md:col-4 xl:col-2 xl:pr-5">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">SUBJECT</label>
        <strong *ngIf="!showSkeleton" class="block white-space-nowrap text-overflow-ellipsis overflow-hidden">Untitled Campaign Untitled Campaign</strong>
        </div> -->
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:col-2 xl:pr-5">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.FROM_NAME' | translate}}</label>
                          <strong *ngIf="!showSkeleton" class="block white-space-nowrap text-overflow-ellipsis overflow-hidden">{{emailConfigMaster.name_primary_language}}</strong>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="7rem"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:col-2 xl:pr-5">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.FROM_EMAIL' | translate}}</label>
                          <strong *ngIf="!showSkeleton" class="block white-space-nowrap text-overflow-ellipsis overflow-hidden">{{emailConfigMaster.from_email}}</strong>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="7rem"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <!-- <div class="col-6 md:col-4 xl:col-2 xl:pr-5">
          <label class="font-medium text-700 text-xs mb-2 block uppercase">REPLY TO</label>
          <strong *ngIf="!showSkeleton" class="block white-space-nowrap text-overflow-ellipsis overflow-hidden">marketing@activ8gym.com</strong>
          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="7rem"></p-skeleton>
          </div> -->
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:col-2 xl:pr-5">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.UPDATED_ON' | translate}}</label>
                          <strong *ngIf="!showSkeleton" class="block">{{campaAction.updated_date | datetimeformat :'defaultformat'}}</strong>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="7rem"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:col-2">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.ACTION_DATE' | translate}}</label>
                          <strong *ngIf="!showSkeleton" class="block">{{campaAction.action_date | datetimeformat :'datetime'}}</strong>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="7rem"></p-skeleton>
                      </div>
                      <!-- Column -->
                  </div>
                  <!-- Grid -->

                  <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-2 mb-3" />

                  <h6 class="mb-3 text-sm flex align-items-center">{{'CAMPAIGN.EMAIL_STATS' | translate}} <i class="fa fa-info-circle ml-2 text-600" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i></h6>

                  <!-- Grid -->
                  <div class="grid mb-2">
                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>{{'CAMPAIGN.RECEPIENT' | translate}}</span>
                              <strong>{{campaAction.email_total_count}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.email_total_count / campaAction.email_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>{{'CAMPAIGN.OPENS' | translate}}</span>
                              <strong>{{campaAction.email_open}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.email_open / campaAction.email_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>{{'CAMPAIGN.DELIVERED' | translate}}</span>
                              <strong>{{campaAction.email_delivered}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.email_delivered / campaAction.email_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>{{'CAMPAIGN.CLICKS' | translate}}</span>
                              <strong>{{campaAction.email_click}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.email_click / campaAction.email_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>BOUNCES</span>
                              <strong>{{campaAction.email_bounced}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.email_bounced / campaAction.email_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>UNSUBSCRIBES</span>
                              <strong>{{campaAction.email_unsubscribe}}</strong>
                          </label>  
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.email_unsubscribe / campaAction.email_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->
                  </div>
                  <!-- Grid -->
              </div>
              <!-- Block Body -->
          </div>
          <!-- Email Block -->

          <!-- SMS Block -->
          <div class="bg-pink-50 border-1 border-pink-500 border-round mt-3" *ngIf="showSmsData.value">
              <!-- Block Header -->
              <div class="border-round-top flex align-items-center bg-pink-500 text-white p-3">
                  <i class="fa fa-comments mr-2"></i>
                  <strong>Send SMS</strong>
              </div>
              <!-- Block Header -->

              <!-- Block Body -->
              <div class="px-3 pt-3 pb-1">
                  <strong *ngIf="!showSkeleton" class="block text-base text-pink-500">{{campaAction.sms_total_count}} Recipients</strong>
                  <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="14rem"></p-skeleton>

                  <!-- Grid -->
                  <div class="grid align-items-center mt-3">
                      <!-- Column -->
                      <div class="col-6 md:col-4">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">FROM MOBILE NUMBER</label>
                          <strong *ngIf="!showSkeleton" class="block">{{smsConfigMaster ? smsConfigMaster.from_number : ''}}</strong>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">UPDATED ON</label>
                          <strong *ngIf="!showSkeleton" class="block">{{campaAction.updated_date | datetimeformat :'defaultformat'}}</strong>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase"> {{'CAMPAIGN.ACTION_DATE' | translate}}</label>
                          <strong *ngIf="!showSkeleton" class="block">{{campaAction.action_date | datetimeformat :'datetime'}}</strong>
                      </div>
                      <!-- Column -->
                  </div>
                  <!-- Grid -->

                  <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-2 mb-3" />

                  <h6 class="mb-3 text-sm flex align-items-center">{{'CAMPAIGN.SMS_STAT' | translate}} <i class="fa fa-info-circle ml-2 text-600" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i></h6>

                  <!-- Grid -->
                  <div class="grid mb-2">
                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>{{'CAMPAIGN.RECEPIENT' | translate}}</span>
                              <strong>{{campaAction.sms_total_count}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.sms_sent / campaAction.sms_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>{{'CAMPAIGN.DELIVERED' | translate}}</span>
                              <strong>{{campaAction.sms_delivered}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.sms_delivered / campaAction.sms_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->
                  </div>
                  <!-- Grid -->
              </div>
              <!-- Block Body -->
          </div>
          <!-- SMS Block -->

          <!-- Whatsapp Block -->
          <div class="bg-green-50 border-1 border-green-500 border-round mt-3" *ngIf="showWhatsappData.value">
              <!-- Block Header -->
              <div class="border-round-top flex align-items-center bg-green-500 text-white p-3">
                  <i class="fab fa-whatsapp mr-2"></i>
                  <strong>{{'CAMPAIGN.TABLE.SEND_WHATSAPP' | translate}}</strong>
              </div>
              <!-- Block Header -->

              <!-- Block Body -->
              <div class="px-3 pt-3 pb-1">
                  <strong *ngIf="!showSkeleton" class="block text-base text-green-500">{{campaAction.whatsapp_total_count}} Recipients</strong>
                  <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="14rem"></p-skeleton>

                  <!-- Grid -->
                  <div class="grid align-items-center mt-3">
                      <!-- Column -->
                      <div class="col-6 md:col-4">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.FROM_NUMBER' | translate}}</label>
                          <strong *ngIf="!showSkeleton" class="block">{{whatsappConfigMaster ? whatsappConfigMaster.display_phonenumber : ''}}</strong>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.UPDATED_ON' | translate}}</label>
                          <strong *ngIf="!showSkeleton" class="block">{{ isNotDefaultDate(campaAction.updated_date) ? (campaAction.updated_date | datetimeformat : 'defaultformat') : '-'}}</strong>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.ACTION_DATE' | translate}}</label>
                          <strong *ngIf="!showSkeleton" class="block">{{ isNotDefaultDate(campaAction.action_date) ? (campaAction.action_date | datetimeformat : 'datetime') : '-'}}</strong>
                      </div>
                      <!-- Column -->
                  </div>
                  <!-- Grid -->

                  <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-2 mb-3" />

                  <h6 class="mb-3 text-sm flex align-items-center">{{'CAMPAIGN.WHATSAPP_STAT' | translate}} <i class="fa fa-info-circle ml-2 text-600" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i></h6>

                  <!-- Grid -->
                  <div class="grid mb-2">
                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>{{'CAMPAIGN.RECEPIENT' | translate}}</span>
                              <strong>{{campaAction.whatsapp_total_count}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="(campaAction.whatsapp_total_count / campaAction.whatsapp_total_count) * 100" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>{{'CAMPAIGN.DELIVERED' | translate}}</span>
                              <strong>{{campaAction.whatsapp_delivered}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.whatsapp_delivered / campaAction.whatsapp_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6" *ngIf="'whatsapp_read' in campaAction">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>{{'CAMPAIGN.READ' | translate}}</span>
                              <strong>{{campaAction.whatsapp_read}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.whatsapp_read / campaAction.whatsapp_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:pr-6">
                          <label class="font-medium text-700 text-xs mb-2 flex align-items-center justify-content-between uppercase">
                              <span>{{'CAMPAIGN.FAILED' | translate}}</span>
                              <strong>{{campaAction.whatsapp_failed}}</strong>
                          </label>
                          <p-progressBar *ngIf="!showSkeleton" [value]="+(((campaAction.whatsapp_failed / campaAction.whatsapp_total_count) * 100).toFixed(0))" unit="%" styleClass="h-1rem text-xs"></p-progressBar>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="100%"></p-skeleton>
                      </div>
                      <!-- Column -->
                  </div>
                  <!-- Grid -->
              </div>
              <!-- Block Body -->
          </div>
          <!-- Whatsapp Block -->

          <!-- Tasks Block -->
          <div class="bg-orange-50 border-1 border-orange-400 border-round mt-3" *ngIf="showTask.value">
              <!-- Block Header -->
              <div class="border-round-top flex align-items-center bg-orange-500 text-white p-3">
                  <i class="fa fa-phone mr-2"></i>
                  <strong>{{'CAMPAIGN.ADD_TO_CALL' | translate}}</strong>
              </div>
              <!-- Block Header -->

              <!-- Block Body -->
              <div class="px-3 pt-3 pb-1">
                  <strong *ngIf="!showSkeleton" class="block text-base text-orange-500">{{campaAction.task_total_count}} call lists created</strong>
                  <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="14rem"></p-skeleton>

                  <!-- Grid -->
                  <div class="grid align-items-center mt-3">
                      <!-- Column -->
                      <div class="col-5 md:col-4 xl:col-2">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.TASK_CATEGORY' | translate}}</label>
                          <strong *ngIf="!showSkeleton&& getCategoryDetails(taskActionPayload.category_id)! as category" class="block">{{category.name_primary_language || category.name_secondary_language}}</strong>
                          <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="6rem"></p-skeleton>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-7 md:col-4 xl:col-3">
                          <div class="flex">
                              <div>
                                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.TASK_CATEGORY' | translate}}</label>
                                  <div *ngIf="!showSkeleton" class="flex align-items-center">
                                      <i class="fa fa-phone mr-2"></i>
                                      <strong class="block">{{taskActionPayload.type}}</strong>
                                  </div>
                                  <div *ngIf="showSkeleton" class="flex align-items-center">
                                      <p-skeleton height="1rem" width="1rem" styleClass="mr-2"></p-skeleton>
                                      <p-skeleton height="1.35rem" width="5rem"></p-skeleton>
                                  </div>
                              </div>

                              <div class="pl-5 xl:pl-8 xl:ml-3">
                                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.PRIORITY' | translate}}</label>
                                  <strong *ngIf="!showSkeleton" class="block">{{taskActionPayload.priority}}</strong>
                                  <p-skeleton *ngIf="showSkeleton" height="1.35rem" width="5rem"></p-skeleton>
                              </div>
                          </div>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:col-2">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.ASSIGNED_TO' | translate}}</label>
                          <div *ngIf="!showSkeleton && getStaffDetails(taskActionPayload.assigned_to_staff_id) as staff" class="relative">
                              <div class="flex align-items-center cursor-pointer" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                                  <ng-container *ngIf="staff.ff_picture;else noImage">
                                    <p-avatar [image]="staff.ff_picture" shape="" styleClass="mr-2 overflow-hidden border-round"></p-avatar>
                                    </ng-container>
                                    <ng-template #noImage>
                                        <p-avatar [label]="client2LetterName(staff.name) | titlecase | shortName" shape="" styleClass="mr-2 overflow-hidden border-round"></p-avatar>
                                    </ng-template>
                                  
                                  <span class="text-primary text-sm">{{staff.name}}</span>
                              </div>

                              <!-- Dropdown -->
                              <div class="border-round shadow-2 absolute text-600 hidden origin-top w-22rem left-0 top-0 mt-6 z-2">
                                  <!-- Dropdown Content -->
                                  <div class="surface-0 flex align-items-center justify-content-between p-3">
                                      <div class="flex align-items-center">
                                          <span class="text-base font-medium text-800">{{ staff.department }}</span>
                                      </div>
                                      <span class="text-xxs border-1 border-primary border-round text-primary bg-blue-50 p-1 uppercase font-bold">{{ staff.designation }}</span>
                                  </div>
                                  <!-- Dropdown Content -->

                                  <!-- Dropdown Footer -->
                                  <div class="p-3 flex align-items-center justify-content-between surface-200 text-900">
                                      <div class="flex align-items-center">
                                          <i class="fa fa-phone mr-2 text-500"></i>
                                          {{ staff.mobile_country_code }} {{ staff.mobile_number }}
                                      </div>
                                      <div class="flex align-items-center">
                                          <i class="fa fa-envelope mr-2 text-500"></i>
                                          {{ staff.email_id }}
                                      </div>
                                  </div>
                                  <!-- Dropdown Footer -->
                              </div>
                              <!-- Dropdown -->
                          </div>

                          <div *ngIf="showSkeleton" class="flex align-items-center">
                              <p-skeleton height="2rem" width="2rem" styleClass="border-round mr-2"></p-skeleton>
                              <p-skeleton height="1.35rem" width="5rem"></p-skeleton>
                          </div>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:col-1">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.SCHEDULE' | translate}}</label>
                          <strong *ngIf="!showSkeleton" class="block">{{taskActionPayload.scheduled_date | datetimeformat :'defaultformat'}}</strong>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:col-2">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.REPEAT' | translate}}</label>
                          <strong *ngIf="!showSkeleton && taskActionPayload.repeat_rule && taskActionPayload.repeat_rule !==''" class="block">{{ taskActionPayload.repeat_rule }}</strong>
                          <strong *ngIf="!showSkeleton && taskActionPayload.repeat_rule && taskActionPayload.repeat_rule ===''" class="block">None</strong>
                      </div>
                      <!-- Column -->

                      <!-- Column -->
                      <div class="col-6 md:col-4 xl:col-2">
                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.TITLE' | translate}}</label>
                          <strong *ngIf="!showSkeleton" class="block">{{taskActionPayload.title}}</strong>
                      </div>
                      <!-- Column -->
                  </div>
                  <!-- Grid -->
              </div>
              <!-- Block Body -->
          </div>
          <!-- Tasks Block -->
      </div>
      <!-- Card Body -->
  </div>
  <!-- Card -->
</div>
<!-- Body Content-->
